/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3MetricsMaxTransactionsPerSecOver90DaysFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3MetricsMaxTransactionsPerSecOver90DaysFormat = ClosedEnum<
  typeof GetApiV3MetricsMaxTransactionsPerSecOver90DaysFormat
>;

export type GetApiV3MetricsMaxTransactionsPerSecOver90DaysRequest = {
  format?: GetApiV3MetricsMaxTransactionsPerSecOver90DaysFormat | undefined;
};

/** @internal */
export const GetApiV3MetricsMaxTransactionsPerSecOver90DaysFormat$inboundSchema:
  z.ZodNativeEnum<typeof GetApiV3MetricsMaxTransactionsPerSecOver90DaysFormat> =
    z.nativeEnum(GetApiV3MetricsMaxTransactionsPerSecOver90DaysFormat);

/** @internal */
export const GetApiV3MetricsMaxTransactionsPerSecOver90DaysFormat$outboundSchema:
  z.ZodNativeEnum<typeof GetApiV3MetricsMaxTransactionsPerSecOver90DaysFormat> =
    GetApiV3MetricsMaxTransactionsPerSecOver90DaysFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsMaxTransactionsPerSecOver90DaysFormat$ {
  /** @deprecated use `GetApiV3MetricsMaxTransactionsPerSecOver90DaysFormat$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsMaxTransactionsPerSecOver90DaysFormat$inboundSchema;
  /** @deprecated use `GetApiV3MetricsMaxTransactionsPerSecOver90DaysFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsMaxTransactionsPerSecOver90DaysFormat$outboundSchema;
}

/** @internal */
export const GetApiV3MetricsMaxTransactionsPerSecOver90DaysRequest$inboundSchema:
  z.ZodType<
    GetApiV3MetricsMaxTransactionsPerSecOver90DaysRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    format: GetApiV3MetricsMaxTransactionsPerSecOver90DaysFormat$inboundSchema
      .default("json"),
  });

/** @internal */
export type GetApiV3MetricsMaxTransactionsPerSecOver90DaysRequest$Outbound = {
  format: string;
};

/** @internal */
export const GetApiV3MetricsMaxTransactionsPerSecOver90DaysRequest$outboundSchema:
  z.ZodType<
    GetApiV3MetricsMaxTransactionsPerSecOver90DaysRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3MetricsMaxTransactionsPerSecOver90DaysRequest
  > = z.object({
    format: GetApiV3MetricsMaxTransactionsPerSecOver90DaysFormat$outboundSchema
      .default("json"),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsMaxTransactionsPerSecOver90DaysRequest$ {
  /** @deprecated use `GetApiV3MetricsMaxTransactionsPerSecOver90DaysRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsMaxTransactionsPerSecOver90DaysRequest$inboundSchema;
  /** @deprecated use `GetApiV3MetricsMaxTransactionsPerSecOver90DaysRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsMaxTransactionsPerSecOver90DaysRequest$outboundSchema;
  /** @deprecated use `GetApiV3MetricsMaxTransactionsPerSecOver90DaysRequest$Outbound` instead. */
  export type Outbound =
    GetApiV3MetricsMaxTransactionsPerSecOver90DaysRequest$Outbound;
}

export function getApiV3MetricsMaxTransactionsPerSecOver90DaysRequestToJSON(
  getApiV3MetricsMaxTransactionsPerSecOver90DaysRequest:
    GetApiV3MetricsMaxTransactionsPerSecOver90DaysRequest,
): string {
  return JSON.stringify(
    GetApiV3MetricsMaxTransactionsPerSecOver90DaysRequest$outboundSchema.parse(
      getApiV3MetricsMaxTransactionsPerSecOver90DaysRequest,
    ),
  );
}

export function getApiV3MetricsMaxTransactionsPerSecOver90DaysRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3MetricsMaxTransactionsPerSecOver90DaysRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3MetricsMaxTransactionsPerSecOver90DaysRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3MetricsMaxTransactionsPerSecOver90DaysRequest' from JSON`,
  );
}
